import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import * as React from 'react';
import { FlexBox } from '../box';
import { Divider } from '../divider';
import { IconDragIndicator } from '../icon';
import { styled } from '../styled';
const DragHandle = styled(FlexBox)(({ theme, isOverlay, isDragging }) => ({
    cursor: isOverlay || isDragging ? 'grabbing' : 'grab',
    userSelect: 'none',
    color: theme.palette.action.active,
    flexShrink: 0,
    flexGrow: 0,
    flexBasis: 30,
    '&:active': isOverlay
        ? undefined
        : {
            cursor: 'grabbing'
        }
}));
const ItemContainer = styled(FlexBox)(({ theme, isOverlay, isDragging, withoutHandle, itemTransform, itemTransition }) => ({
    opacity: isDragging ? 0.5 : 1,
    border: isDragging
        ? `1px dashed ${theme.palette.primary.light}`
        : undefined,
    boxShadow: isOverlay ? theme.shadows[2] : undefined,
    cursor: withoutHandle
        ? isOverlay || isDragging
            ? 'grabbing'
            : 'grab'
        : undefined,
    transform: itemTransform,
    transition: itemTransition,
    '& > *': {
        transition: theme.transitions.create('background-color', {
            duration: 0
        }),
        ...(isDragging && {
            backgroundColor: 'transparent !important'
        })
    },
    ...(!isDragging && {
        '&:hover': {
            '& > *': {
                backgroundColor: theme.palette.action.hover
            }
        }
    })
}));
export const SortableItem = ({ item, id, isOverlay, renderItem, dragHandleAriaLabel, withoutDivider = false, withoutHandle = false }) => {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id, disabled: isOverlay });
    const itemTransform = isOverlay
        ? undefined
        : CSS.Transform.toString(transform);
    const itemTransition = isOverlay ? undefined : transition;
    const dragHandle = !withoutHandle ? (_jsx(DragHandle, { ref: isOverlay ? undefined : setActivatorNodeRef, ...(isOverlay ? {} : attributes), ...(isOverlay ? {} : listeners), vAlign: "center", hAlign: "center", "aria-label": dragHandleAriaLabel, paddingLeft: 1, isOverlay: isOverlay, isDragging: isDragging, children: _jsx(IconDragIndicator, { fontSize: "small" }) })) : null;
    return (_jsxs(_Fragment, { children: [_jsxs(ItemContainer, { ref: isOverlay ? undefined : setNodeRef, isOverlay: isOverlay, isDragging: isDragging, withoutHandle: withoutHandle, itemTransform: itemTransform, itemTransition: itemTransition, ...(withoutHandle && !isOverlay ? attributes : {}), ...(withoutHandle && !isOverlay ? listeners : {}), children: [dragHandle, renderItem(item, { isOverlay, isDragging })] }), !isOverlay && !withoutDivider && _jsx(Divider, {})] }));
};
